// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jnmN","title":"Header_title__uQ54-","left":"Header_left__1upZg","clinicName":"Header_clinicName__1iUbh"};